const PortugueseIcon = (props) => (
    <svg version="1.1" id="Layer_1" x="0rem" y="0rem" viewBox="0 0 512 512" with={props.with} height={props.height}>
        <rect y="85.337" fill="#D80027" width="512" height="341.326" />
        <polygon fill="#6DA544" points="196.641,85.337 196.641,261.565 196.641,426.663 0,426.663 0,85.337 " />
        <circle fill="#FFDA44" cx="196.641" cy="256" r="64" />
        <path fill="#D80027" d="M160.638,224v40.001c0,19.882,16.118,36,36,36s36-16.118,36-36V224H160.638z" />
        <path fill="#F0F0F0" d="M196.638,276c-6.617,0-12-5.383-12-12v-16h24.001v16C208.638,270.616,203.254,276,196.638,276z" />
    </svg>
);

export default PortugueseIcon;
